import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <>
      <footer>
        <ul className="sitemap">
          <li>
            <Link to="/sitemap/about">회사소개</Link>
          </li>
          <li>
            <Link to="/sitemap/policy">이용약관</Link>
          </li>
          <li>
            <Link to="/info/bookstore">서점안내</Link>
          </li>
          <li>
            <Link to="/board/notice">고객센터</Link>
          </li>
          <li>
            <Link to="/board/books-all">도서목록</Link>
          </li>
        </ul>
        <div className="wrapper">
          <ul className="information">
            <li>
              <address>
                주소: (07293) 서울 영등포구 문래북로 116, 604~605호(문래동 3가, 트리플렉스)
              </address>
            </li>
            <li>전화번호: 02-701-7421</li>
            <li>팩스번호: 02-3273-9642</li>
            <li>사업자등록번호: 101-98-52093</li>
            <li>통신판매신고번호: 제2014-서울영등포-0492호</li>
            <li>대표이사: 조규백</li>
            <li>
              대표이메일:&nbsp;
              <a href="mailto:kuhminsa@kuhminsa.co.kr">kuhminsa@kuhminsa.co.kr</a>
            </li>
            <li>호스팅제공자: (주)아이티칸</li>
            <li>도서출판 구민사 CopyrightⓒKuhminsa all right Reserved.</li>
          </ul>
          <div className="logo" />
        </div>
      </footer>
      <nav className="mobile-navigation">
        <a href="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
          </svg>
          <small>홈</small>
        </a>
        {window.localStorage.getItem('token') === null ? null : (
          <a href="/order/shipping">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
            </svg>
            <small>주문배송</small>
          </a>
        )}
        <a href="/order/cart">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path d="M6 2L3 6v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V6l-3-4H6zM3.8 6h16.4M16 10a4 4 0 1 1-8 0" />
          </svg>
          <small>장바구니</small>
        </a>
        <a href="/board/notice">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z" />
          </svg>
          <small>고객센터</small>
        </a>
        {window.localStorage.getItem('token') === null ||
        window.localStorage.getItem('authority') !== 'A' ? (
          <></>
        ) : (
          <a href="/admin">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" />
            </svg>
            <small>관리자</small>
          </a>
        )}
      </nav>
    </>
  );
}

// export default Footer;
